/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

interface ITokenPayload {
  exp: number,
  [key: string]: any,
}

export default class Token {
  public isTokenExpired (token: string = '') {
    if (!token) {
      return true
    }
    const expirationDate: Date = this.getExpirationDate(token)
    return expirationDate.valueOf() <= new Date().valueOf()
  }

  public getExpirationDate (token: string) {
    const payload = this.getTokenPayload(token)
    const date = new Date(0)

    date.setUTCSeconds(payload.exp)

    return date
  }

  public getTokenPayload (token: string): ITokenPayload {
    if (token && token.split('.').length === 3) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(
          decodeURIComponent(encodeURIComponent(window.atob(base64))),
        )
      } catch (e) {
        return undefined
      }
    }
  }
}
